export function useAppToast() {
  const toast = useToast()

  function success({
    title,
    description
  }: {
    title?: string
    description?: string
  }) {
    toast.add({
      title,
      description,
      color: 'success',
      icon: 'lucide:check-circle'
    })
  }

  function error({
    title,
    description
  }: {
    title?: string
    description?: string
  }) {
    toast.add({
      title,
      description,
      color: 'error',
      icon: 'lucide:x-circle'
    })
  }

  function info({
    title,
    description
  }: {
    title?: string
    description?: string
  }) {
    toast.add({
      title,
      description,
      color: 'info',
      icon: 'lucide:info'
    })
  }

  return {
    success,
    error,
    info
  }
}
